export const dontShowLeaveAtGateOptionForSSRs = ['AVIH', 'PETC']
